import {Component, OnInit} from '@angular/core';


@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: [
    './../../../shared/style/main.scss',
    './../../../shared/style/form.scss',
    './maintenance.component.scss'
  ]
})
export class MaintenanceComponent implements OnInit {
  public status: boolean;

  constructor() {
    this.status = false;
  }

  ngOnInit() {
  }

  updateStatus(status) {
    this.status = status;
  }
}
